import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import { StyledSmallSectionHeader } from 'containers/ASIDashboard/MyContracts/styles';
import CustomCarousel from 'components/CustomCarousel';
import messages from 'containers/ASIDashboard/messages';
import { translate } from 'helpers/intl';
import { ASIInfoCard } from 'components/ItemInfoCard';
import { CONTRACT_STATUSES } from 'utils/globalConst';

const MyContracts = (props: {
  intl: IntlShape;
  contracts: any;
  setDetailsPageBreadcrumbsPath: Function;
}) => {
  return (
    <>
      <StyledSmallSectionHeader>
        {translate({ ...messages.title }, props)}
      </StyledSmallSectionHeader>
      <CustomCarousel showIndicators={props.contracts.length > 1}>
        {props.contracts.map(
          (
            contract: {
              status: string;
              adresse: string;
              id: string;
              policyNumber: string;
              product: string;
            },
            index: any,
          ) => (
            <ASIInfoCard
              key={index}
              status={
                contract.status === CONTRACT_STATUSES.ACTIVE
                  ? 'success'
                  : 'error'
              }
              statusLabel={
                contract.status === CONTRACT_STATUSES.ACTIVE
                  ? translate({ ...messages.Actif }, props)
                  : translate({ ...messages.Encours }, props)
              }
              title={contract.product}
              firstInformationLabel={translate({ ...messages.id }, props)}
              firstInformationValue={contract.id}
              secondInformationLabel={translate(
                { ...messages.policyNumber },
                props,
              )}
              secondInformationValue={contract.policyNumber}
              wrapperPaddingRight={
                index === props.contracts.length - 1 ? '24px' : '45px'
              }
              wrapperPaddingLeft={index === 0 ? '24px' : '45px'}
              setDetailsPageBreadcrumbsPath={
                props.setDetailsPageBreadcrumbsPath
              }
            />
          ),
        )}
      </CustomCarousel>
    </>
  );
};

export default injectIntl(MyContracts);
